import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map, Observable, shareReplay } from 'rxjs';
import { Sector } from '../models/sector';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SectorService {
  API_URL = `${environment.apiUrl}/sectors`;
  CACHE_SIZE = 1;
    private cache$!: Observable<Array<Sector>>;
    isSectorLoading$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {}

  get sectors() {
      if (!this.cache$) {
        this.cache$ = this.requestSectors().pipe(shareReplay(this.CACHE_SIZE));
        this.isSectorLoading$.next(true);
      }
      this.isSectorLoading$.next(false);
      return this.cache$;
    }
  
    private requestSectors() {
      return this.http.get<Sector[]>(this.API_URL);
    }

  getSectors(): Observable<Sector[]> {
    return this.http.get<Sector[]>(this.API_URL).pipe(
      map(sectors => sectors.sort((a, b) => {
          const dateA = a.modifiedDate ? new Date(a.modifiedDate).getTime() : 0;
          const dateB = b.modifiedDate ? new Date(b.modifiedDate).getTime() : 0;
          if (dateB !== dateA) {
            return dateB - dateA;
          }
          return (b.id ?? 0) - (a.id ?? 0);
        }))
      );
  }

  addSector(sector: Sector): Observable<Sector> {
    return this.http.post<Sector>(this.API_URL, sector);
  }

  updateSector(sector: Sector): Observable<Sector> {
    return this.http.put<Sector>(`${this.API_URL}/${sector.id}`, sector);
  }

  deleteSector(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }
}
